'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CampaignContactDetailController = function () {
    /* @ngInject */
    function CampaignContactDetailController($scope, $state, $stateParams, $ionicLoading, $q, ApiContacts, ApiCampaigns, ApiTasks, DATE_FORMAT, ApiPicklist, $ionicPopup, $filter, MessageBox) {
        _classCallCheck(this, CampaignContactDetailController);

        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$ionicLoading = $ionicLoading;
        this.$q = $q;
        this.ApiContacts = ApiContacts;
        this.ApiCampaigns = ApiCampaigns;
        this.ApiTasks = ApiTasks;
        this.ApiPicklist = ApiPicklist;
        this.DATE_FORMAT = DATE_FORMAT;
        this.contact = {};
        this.contactId = $stateParams.contactId;
        this.$ionicLoading = $ionicLoading;
        this.campaignId = $stateParams.campaignId;
        this.contactNotesLocked = true;
        this.campaignCurrencySymbol = '';
        this.$ionicPopup = $ionicPopup;
        this.$filter = $filter;
        this.MessageBox = MessageBox;
        this.ApiTasks = ApiTasks;

        this.filterParams = {
            isCustomerContact: undefined,
            firstQueryResult: undefined
        };

        this.cleaveNumeral = {
            numeral: true,
            numeralThousandsGroupStyle: 'thousand'
        };
    }

    _createClass(CampaignContactDetailController, [{
        key: 'init',
        value: function init() {
            this.$ionicLoading.show({
                template: '<spinner-advinda></spinner-advinda>',
                duration: 10000
            });

            this.getCurrencies();
            this.getCampaign();
            this.getCampaignContact();
            this.createRedirectPathInTaskService();
        }
    }, {
        key: 'getCampaignContact',
        value: function getCampaignContact() {
            var _this = this;

            this.ApiCampaigns.getCampaignContact(this.campaignId, this.contactId).then(function (res) {
                if (typeof res != 'undefined') {
                    var isCustomerContact = !!res.contactInfo.contact.customer;
                    _this.contact = res;
                    _this.getContactExtenstionIds(res.contactInfo.contact.id, isCustomerContact);

                    if (_this.contact.dateTeaserSent) {
                        _this.contact.dateTeaserSent = new Date(_this.contact.dateTeaserSent); // avoid date issue
                    } else {
                        _this.contact.dateTeaserSent = _this.DATE_FORMAT;
                    }

                    if (_this.contact.memberStatusUpdated) {
                        _this.contact.memberStatusUpdated = new Date(_this.contact.memberStatusUpdated); // avoid date issue
                    } else {
                        _this.contact.memberStatusUpdated = _this.DATE_FORMAT;
                    }

                    _this.contact.levelOfInterest = _this.contact.levelOfInterest + '-lOI';
                    _this.$ionicLoading.hide();
                } else {
                    _this.$ionicLoading.hide();
                }
            });
        }
    }, {
        key: 'getContactExtenstionIds',
        value: function getContactExtenstionIds(contactId, isCustomerContact) {
            var _this2 = this;

            // pre-filter the task data for this contact
            this.ApiContacts.getContactExtensionIds(contactId, {
                isCustomerContact: isCustomerContact
            }).then(function (res) {
                if (res) {
                    _this2.taskParameters = {
                        contactExtensionIds: res,
                        contactId: contactId,
                        isCustomerContact: isCustomerContact
                    };
                } else {
                    _this2.taskParameters = {
                        contactExtensionIds: [contactId],
                        contactId: contactId,
                        isCustomerContact: isCustomerContact
                    };
                }

                if (_this2.campaignId) {
                    _this2.taskParameters.campaignIds = [_this2.campaignId];
                }
            });
        }
    }, {
        key: 'onSaveClicked',
        value: function onSaveClicked() {
            if (!this.checkIflevelOfInterestHasPromisedInvestment() || this.contact.promisedInvestment == '') this.changePromisedInvestmentToZero();
            this.campaignContactUpdate();
        }
    }, {
        key: 'campaignContactUpdate',
        value: function campaignContactUpdate() {
            var _this3 = this;

            delete this.tempContact;
            this.contact.levelOfInterest = this.contact.levelOfInterest.substring(0, this.contact.levelOfInterest.length - 4);
            if (this.contact.dateTeaserSent === this.DATE_FORMAT) {
                this.contact.dateTeaserSent = null;
            }
            if (this.contact.memberStatusUpdated === this.DATE_FORMAT) {
                this.contact.memberStatusUpdated = null;
            }

            this.ApiCampaigns.updateCampaignContact(this.campaignId, this.contactId, this.contact).then(function (res) {
                _this3.contact = res;

                _this3.contact.dateTeaserSent = _this3.setDate(_this3.contact.dateTeaserSent);
                _this3.contact.memberStatusUpdated = _this3.setDate(_this3.contact.memberStatusUpdated);

                _this3.contact.levelOfInterest = _this3.contact.levelOfInterest + '-lOI';
                _this3.contactNotesLocked = !_this3.contactNotesLocked;
            });
        }
    }, {
        key: 'setDate',
        value: function setDate(date) {
            if (date) {
                return new Date(date); // avoid date issue
            }
            return this.DATE_FORMAT;
        }
    }, {
        key: 'getCurrencies',
        value: function getCurrencies() {
            var _this4 = this;

            this.ApiPicklist.getCurrencies().then(function (currencies) {
                if (currencies) {
                    _this4.currencies = currencies;
                }
            });
        }
    }, {
        key: 'getCampaign',
        value: function getCampaign() {
            var _this5 = this;

            this.ApiCampaigns.getCampaign(this.campaignId).then(function (campaign) {
                if (campaign) {
                    _this5.campaign = campaign;
                    _this5.campaignCurrencySymbol = _this5.getCurrency(campaign.campaignCurrency)[0].symbol;
                }
            });
        }
    }, {
        key: 'getCurrency',
        value: function getCurrency(currencyCode) {
            return this.currencies.data.filter(function (c) {
                return c.shortName === currencyCode;
            });
        }
    }, {
        key: 'popUp',
        value: function popUp($event) {
            var _this6 = this;

            $event.preventDefault();
            var dialogResult = this.$ionicPopup.confirm({
                title: this.$filter('translate')('REMOVE_CONTACT'),
                template: this.$filter('translate')('REMOVE_CAMPAIGN_CONTACT')
            });

            dialogResult.then(function (res) {
                if (res) {
                    _this6.removeCampaignContact(_this6.contact);
                }
            });
        }
    }, {
        key: 'removeCampaignContact',
        value: function removeCampaignContact(contact) {
            var _this7 = this;

            var contactIds = { contactIds: [contact.id] };
            this.ApiCampaigns.deleteCampaignContact(this.campaignId, contactIds).then(function (res) {
                if (res) {
                    if (res.length > 0 && !_this7.checkIfContactExistsInCampaign(contact, res[0])) {
                        _this7.$state.go('campaignDetail', { campaignId: _this7.campaignId }, { reload: true });
                    } else {
                        _this7.MessageBox.showFailMessage('CAMPAIGN_CONTACT', 'REMOVE');
                    }
                } else if (res == null) {
                    _this7.$state.go('campaignDetail', { campaignId: _this7.campaignId }, { reload: true });
                }
            });
        }
    }, {
        key: 'checkIfContactExistsInCampaign',
        value: function checkIfContactExistsInCampaign(contact, campaign) {
            if (!contact || !campaign) throw new Exception('Invalid contact or campaign supplied to checkIfContactExistsInCampaign()');

            if (campaign.contactInfo && campaign.contactInfo.contact) {
                if (contact.contactInfo && contact.contactInfo.contact) {
                    return campaign.contactInfo.contact.id == contact.contactInfo.contact.id;
                }
            } else {
                return false;
            }
        }
    }, {
        key: 'editContactInfo',
        value: function editContactInfo() {
            this.contactNotesLocked = !this.contactNotesLocked;
            this.tempContact = angular.copy(this.contact);
        }
    }, {
        key: 'cancelEdit',
        value: function cancelEdit() {
            this.contactNotesLocked = !this.contactNotesLocked;
            this.contact = angular.copy(this.tempContact);
            delete this.tempContact;
        }
    }, {
        key: 'checkIflevelOfInterestHasPromisedInvestment',
        value: function checkIflevelOfInterestHasPromisedInvestment() {
            var hideInvestment = this.contact.levelOfInterest == '100-lOI' || this.contact.levelOfInterest == '200-lOI' || this.contact.levelOfInterest == '300-lOI' || this.contact.levelOfInterest == '400-lOI' || this.contact.levelOfInterest == '1100-lOI' || this.contact.levelOfInterest == '1200-lOI' || this.contact.levelOfInterest == '500-lOI';
            return !hideInvestment;
        }
    }, {
        key: 'changePromisedInvestmentToZero',
        value: function changePromisedInvestmentToZero() {
            this.contact.promisedInvestment = 0;
        }
    }, {
        key: 'createRedirectPathInTaskService',
        value: function createRedirectPathInTaskService() {
            this.ApiTasks.campaignContactDetailRedirectParams = {};
            this.ApiTasks.campaignContactDetailRedirectParams.contactId = this.$stateParams.contactId;
            this.ApiTasks.campaignContactDetailRedirectParams.campaignId = this.$stateParams.campaignId;
        }
    }]);

    return CampaignContactDetailController;
}();

exports.default = CampaignContactDetailController;


/** WEBPACK FOOTER **
 ** ./src/app/components/campaigns/campaignContactDetail.controller.js
 **/